<div class="notification-card" role="dialog" aria-label="What's new in IntelENGINE">
    <div class="card-header">
        <div class="badge">WHAT'S NEW</div>
        <h2>{{ data.heading }}</h2>
        <p>{{ data.subHeading }}</p>
    </div>

    <div class="tabs" role="tablist" aria-label="Notification steps">
        <button
            *ngFor="let step of data.steps; let index = index"
            type="button"
            class="tab"
            role="tab"
            [attr.aria-controls]="'notification-panel-' + index"
            [attr.aria-selected]="stepIndex === index"
            [class.active]="stepIndex === index"
            (click)="selectStep(index)">
            <span class="tab-icon" *ngIf="step.tabIcon">{{ step.tabIcon }}</span>
            {{ step.tabLabel }}
        </button>
    </div>

    <div class="card-body" role="tabpanel" [id]="'notification-panel-' + stepIndex">
        <p class="description">{{ currentStep.description }}</p>

        <ul *ngIf="currentStep.bullets.length > 0" class="bullets">
            <li *ngFor="let bullet of currentStep.bullets">{{ bullet }}</li>
        </ul>

        <ul *ngIf="currentStep.featureBullets?.length" class="feature-bullets">
            <li *ngFor="let bullet of currentStep.featureBullets">
                <span class="feature-content">
                    <span class="lead">{{ bullet.lead }}:</span>
                    <span class="text">{{ bullet.text }}</span>
                </span>
            </li>
        </ul>

        <div *ngIf="currentStep.highlights?.length || currentStep.coverageGroups?.length" class="highlights">
            <div class="section-title section-title-icon">What it covers</div>

            <div *ngFor="let group of currentStep.coverageGroups" class="coverage-group">
                <div class="group-title">{{ group.icon }} {{ group.label }}</div>
                <div class="chips">
                    <span *ngFor="let chip of group.items" class="chip">{{ chip }}</span>
                </div>
            </div>

            <div *ngIf="!currentStep.coverageGroups?.length" class="chips">
                <span *ngFor="let chip of currentStep.highlights" class="chip">{{ chip }}</span>
            </div>
        </div>

        <div *ngIf="currentStep.tip" class="tip" [ngClass]="currentStep.tipVariant || 'warning'">
            <span *ngIf="currentStep.tipIcon" class="tip-icon">{{ currentStep.tipIcon }}</span>
            {{ currentStep.tip }}
        </div>

        <div class="examples">
            <div class="section-title section-title-tip">Example Questions</div>
            <button type="button" class="example" *ngFor="let example of currentStep.examples">{{ example }}</button>
        </div>
    </div>

    <div class="card-footer">
        <span>{{ stepIndex + 1 }} of {{ data.steps.length }}</span>

        <button type="button" class="cta" (click)="isLastStep ? getStarted() : next()">
            {{ isLastStep ? 'Get started' : 'Next' }}
        </button>
    </div>
</div>
